import { Alert, Stack, Tooltip, Typography } from "@mui/material";
import { DuplicateEmailRecipientRecordType } from "pages/SharedRecords.types";
import { useTranslate } from "react-admin";

type DuplicateRecipientsAlertPropsType = {
  duplicateRecipients: DuplicateEmailRecipientRecordType[];
};

/**
 * Recipient sets are not deduplicated - the same person may be addressed once per
 * booking on purpose. This only makes it visible before sending.
 */
export default function DuplicateRecipientsAlert(props: DuplicateRecipientsAlertPropsType) {
  const { duplicateRecipients } = props;
  const translate = useTranslate();

  if (duplicateRecipients.length === 0) return null;

  const tooltipTitle = (
    <Stack>
      {duplicateRecipients.map((recipient) => (
        <Typography variant="body2" key={recipient.to}>
          {recipient.name ? `${recipient.name} <${recipient.to}>` : recipient.to} ({recipient.count}×)
        </Typography>
      ))}
    </Stack>
  );

  return (
    <Alert severity="warning">
      <Tooltip title={tooltipTitle} arrow>
        <Typography>{translate("resources.emails.hints.duplicateRecipients", duplicateRecipients.length)}</Typography>
      </Tooltip>
    </Alert>
  );
}
